import React from 'react';

export default class YoutubeVideo extends React.Component {

    constructor(props)
    {
        super(props);

        this.state = {
            open: false
        }
    }

    getInitialState() {
        return {
            open: false
        }
    }

    toggleVideo() {
        this.setState({
            open: !this.state.open,
        })
    }

    renderPlayer() {
        return (
            <div className="youtube-preview-player" onClick={this.toggleVideo}>
                <iframe src={ `//www.youtube-nocookie.com/embed/${this.props.youtubeId}?rel=0&autoplay=1` } allowFullScreen frameBorder="0"></iframe>
            </div>
        )
    }

    render() {
        return(
            <div onClick={this.toggleVideo}>
                <img srcSet={ '/media/cache/listing_370/' + this.props.image + ' 370w, /media/cache/listing_485/' +  this.props.image + ' 485w, /media/cache/listing_640/' + this.props.image + ' 640w'} sizes="(min-width: 641px) 485px,(min-width: 640px) 640px, 100vw" src={'/media/cache/listing_640/' + this.props.image} />
                <div className="info">
                    <div className="row">
                        <div className="small-12 columns text-center">
                            <h3>{ this.props.title }</h3>
                            <hr />
                            <div className="button secondary white play">Play</div>
                        </div>
                    </div>
                </div>

                { this.state.open ? this.renderPlayer() : '' }
            </div>
        )
    }
};
